import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionListComponent } from '@items/question-list/question-list.component';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { RoleManagementService } from '@services/role.management.service';
import { WebErrorService } from '@services/webError.service';
// import { Editor } from 'ngx-editor';
import { Subscription } from 'rxjs';
import { AddNewQuestion, GlobalToolbarConfig, Options, QuestionDescription } from 'src/app/shared/addnewquestion';
import { CkeditorConfig,QuestionSubTypeIdEnum, QuestionTypeIdEnum } from 'src/app/shared/config/questions.config';
import { TranslateService } from '@ngx-translate/core';
import * as Editor from '../../../../assets/ckeditor';
import Adapter from '../ckeditorAdapter';

@Component({
  selector: 'app-items-survey-number-rating',
  templateUrl: './items-survey-number-rating.component.html',
  styleUrls: ['./items-survey-number-rating.component.scss']
})
export class ItemsSurveyNumberRatingComponent implements OnInit {
  // @ViewChild(QuestionListComponent) child !: any;
  itemId: any;
  listDisplay = false;
  display: boolean = false;
  saveDataValidation = false;
  saveDisable: boolean = false;
  setAddOption = true;
  editMode = false;
  addOptionEditor = false;
  optionDiv = false;
  deleteOptionId: any;
  questionhtml: any;
  // editor: Editor;
  // editors: Editor[] = [];
  // editor1: Editor;
  option: [];
  questionscoreF = false;
  addQuestionForm: FormGroup;
  addOptions: FormGroup;
  MoreOptionsForm: FormGroup;
  addOptionNew: Options[] = [];
  addedOptions: string[] = []
  arrayForScoreadd: any;
  newArrayforAddOption: any;
  checkSelectionOption = [];
  getQuestionDisplay: string;
  newEvent = 0;
  scoreArray = [];
  correctScorePoint: any;
  questionDisplayValue: string;
  queId: any;
  fetchEditOption: any;
  addnewquestion = new AddNewQuestion();
  addnewquestiondescription = new QuestionDescription();
  @Output() postCreated = new EventEmitter();
  updateOptionText: any;
  dialogResult: any;
  toolbar = GlobalToolbarConfig;
  optionToDelete: number[] = [];
  ckeditorConfig = CkeditorConfig;
  isCkeditorLoading: boolean = true;
  QuestionOrientation: any;
  //-------- CKEditor5 Version---------
  @ViewChild("myEditor") myEditor: any;
  public Editor: any = Editor;
  errorMessage;
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;  public uploadedFileNames = [];
  QuestionImages = []
  imageId: number = 1;
  constructor(private formBuilder: FormBuilder, private notificationServices: NotificationService,
    public questionService: QuestionService, public itemservice: ItemService,
    private routerstate: ActivatedRoute,
    public roleSer: RoleManagementService,
    public dialog: MatDialog,
    private webErrorService: WebErrorService,
    private router: Router,
    private translate: TranslateService,) {
    this.routerstate?.parent?.params?.subscribe((data) => {
      this.itemId = data.id;
    });

    if (sessionStorage.getItem('questionuuId')) {
      this.queId = sessionStorage.getItem('questionuuId');
    } else {
      this.queId = this.router.getCurrentNavigation()?.extras?.state?.queId;
    }

    this.questionService.getQuestionOrientation().subscribe(o => {this.QuestionOrientation = o.data})
  }

  onReady(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessage = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileNames.push(res.fileName)
        this.QuestionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onClick(event) {
    if (this.errorMessage && event) this.errorMessage = false;
  }

  ngOnInit(): void {
    this.saveDisable = false;
    // this.editor = new Editor();
    // this.editor1 = new Editor();

    this.addQuestionForm = new FormGroup({
      questiondescription: new FormGroup({
        description: new FormControl('', Validators.required),
        mediaURL: new FormControl(["string"]),
        file_name: new FormControl(["string"]),
      }),
      Ratinghigh: new FormControl(""),
      Ratinglow: new FormControl(""),
      ansRenderCount: new FormControl(0),
      questiondisplayoptions: new FormControl('Horizontal'),
      checkAnswerAttempt: new FormControl(0),
      minScoreIfAttempt: new FormControl(0),
      penaltyPoints: new FormControl(0),
      questionOrder: new FormControl(0),
      shuffleOption: new FormControl(false),
      autoScoring: new FormControl(false),
      scoringTypeExactMatch: new FormControl(false),
      allowCheckAnswer: new FormControl(false),
      active: new FormControl(true),
      correctPoints: new FormControl(0),
      questionTypeId: new FormControl(QuestionTypeIdEnum.SurveyNumberRating),
      questionSubTypeId: new FormControl(QuestionSubTypeIdEnum.SurveyNumberRating),
      options: new FormArray([]),
      itemId: new FormControl(sessionStorage.getItem('itemId')),
      questionImages: new FormControl('')
    })

    if (this.queId) {
      this.editMode = true;
      const questionServiceGetSubscription: Subscription = this.questionService
        .getQuestion(this.itemId, this.queId)
        .subscribe((resdata) => {
          for (let i = 0; i < resdata.data.options.length; i++) {
            this.optionArray.push(this.generateNumberOption())
          }
          this.addQuestionForm.patchValue(resdata.data);
          this.addQuestionForm.patchValue({
            Ratinglow: resdata.data.ratinglow,
            Ratinghigh: resdata.data.ratinghigh
          })
          this.addQuestionForm.value;
          questionServiceGetSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error);
        });
    } else {
      for (let i = 0; i < 3; i++) {
        this.optionArray.push(this.generateNumberOption())
      }
    }
  }

  generateNumberOption() {
    return new FormGroup({
      optionId: new FormControl('', (Validators.required, Validators.min(0))),
      arrangeOrder: new FormControl(0),
      answerDescription: new FormGroup({
        description: new FormControl("Ten"),
        mediaURL: new FormControl([])
      }),
      correctPoints: new FormControl(0),
      selected: new FormControl(false),
      answerValid: new FormControl(false),
      id: new FormControl(0),
      modified: new FormControl(false),
      sequencialLimit: new FormControl(0),
      isDropDownFormat: new FormControl(false)
    })
  }

  get optionArray() {
    return this.addQuestionForm.get("options") as FormArray
  }

  back() {
    this.postCreated.emit('false');
    this.display = true;
    // this.editor.destroy();
  }

  openOptionDiv() {
    this.optionArray.push(this.generateNumberOption());
    if (this.addQuestionForm.valid) {
      this.setAddOption = false;
      this.optionDiv = true;
      this.addOptionEditor = false;
    } else {
      this.addOptionEditor = true;
    }
  }

  deleteOptionDiv(index: number) {
    if (index) {
      this.optionToDelete.push((<FormArray>this.addQuestionForm.get("options")).at(index).value.id);
      (<FormArray>this.addQuestionForm.get("options")).removeAt(index);
      this.addQuestionForm.get("options").updateValueAndValidity();
    }
  }

  onCkeditorReady() {
    this.isCkeditorLoading = false;
  }

  saveNumberRatingQuestion() {
    this.addOptionNew.forEach(element => {
      this.correctScorePoint = element.correctPoints;
    });

    let question = this.addQuestionForm.value.questiondescription['description'];
    let question1 = question;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();
    if (question1.length == 0) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg3'), true, 'warn')
      return;
    }

    this.addQuestionForm.value.questiondescription['file_name'] = this.uploadedFileNames;

    this.addQuestionForm.value.questiondescription['description'] = question1;

    if (this.QuestionImages.length > 0) {
      this.QuestionImages.forEach(ele => {

        question1 = question1.replace(ele.base64, ele.uniqueId)

        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }
    this.addQuestionForm.value.questiondescription['description'] = question1;
    this.addQuestionForm.value.questionImages = this.QuestionImages;

    if (this.editMode) {
      this.addQuestionForm.controls["options"].value.forEach((element: any) => {
        element.modified = true;
      });

      this.optionToDelete.forEach(optId => {
        this.questionService.deleteOption(this.queId, optId).subscribe(() => { },
        (error) => {
          this.webErrorService.handleAPIErrors(error);
        });
      });
      this.questionService.updateQuestion(this.addQuestionForm.value, this.itemId, this.queId).subscribe((resData) => {
        sessionStorage.removeItem('questionuuId');
        this.itemservice.editedGetItem(resData.data);
        this.notificationServices.success(resData?.message);
        // this.itemservice.questionCountUpdate.next(true);
        // this.questionService.reloadList.next(true);
        this.listDisplay = true;
        // this.back();
      },
      (error) => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
    } else {
      this.questionService.addQuestion(this.addQuestionForm.value, this.itemId).subscribe((resData) => {
        this.notificationServices.success(resData?.message); // This line used to display message
        // this.itemservice.questionCountUpdate.next(true);
        // this.questionService.reloadList.next(true);
        this.listDisplay = true;
        // this.back();
      },
      (error) => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
    }
  }
}
